<div class="driver-location-modal-wrapper">
	<app-driver-location
		[showFullScreen]="data.showFullScreen"
		[stop]="data?.stop"
		[extraData]="data?.extraData">
	</app-driver-location>
</div>
<div class="bottom">
	<button [color]="'accent'" mat-dialog-close mat-raised-button>
		<span>{{'driverLocationView.closeButton' | translate}}</span>
	</button>
</div>
